module.exports = __webpack_public_path__ + "static/media/bg1.2cb1c629.svg";